export const activeFields = {
  // nome: '',
  // celular: '',
  email: '',
}

export const activeValidations = {
  // nome: false,
  // celular: false,
  email: false,
}